import React, {forwardRef, LegacyRef} from 'react';

interface CustomDateInputProps {
    onClick?: () => void;
    value?: string;
}

export default forwardRef((props: CustomDateInputProps, ref) => {
    const {onClick, value = 'Datum auswählen'} = props;

    return (
        <button
            ref={ref as LegacyRef<HTMLButtonElement>}
            onClick={onClick}
            className="button"
            type="button"
        >
            {value}
        </button>
    )
});
